var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "disabled", "onChange", "placeholder", "error", "name", "downloadAttachmentAPI", "downloadAttachmentRequest", "deleteAttachmentAPI", "deleteAttachmentRequest", "uploadButtonProps", "attachmentButtonProps"], _excluded2 = ["item", "onDelete", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { AttachFileOutlined } from '@mui/icons-material';
import { Box, IconButton, InputBase, ListItemIcon, Menu, MenuItem, Stack, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useCallback, useState } from 'react';
import { Delete, PdfFile, Upload } from '../../../assets/svg';
export var FormAttachment = function (props) {
    var _value$length, _buildFilesArray;
    var value = props.value, disabled = props.disabled, onChange = props.onChange, _a = props.placeholder, placeholder = _a === void 0 ? 'Upload files' : _a, error = props.error, name = props.name, downloadAttachmentAPI = props.downloadAttachmentAPI, _b = props.downloadAttachmentRequest, downloadAttachmentRequest = _b === void 0 ? {} : _b, deleteAttachmentAPI = props.deleteAttachmentAPI, _c = props.deleteAttachmentRequest, deleteAttachmentRequest = _c === void 0 ? {} : _c, uploadButtonProps = props.uploadButtonProps, attachmentButtonProps = props.attachmentButtonProps, others = _objectWithoutProperties(props, _excluded);
    var _d = useState(null), anchor = _d[0], setAnchor = _d[1];
    var buildFilesArray = useCallback(function (fileList) {
        if (!fileList)
            return null;
        var newList = fileList === null || fileList === void 0 ? void 0 : fileList.map(function (file, id) {
            if (file instanceof File) {
                return {
                    id: id,
                    Name: file.name,
                    Size: file.size,
                    Type: file.type
                };
            }
            return _objectSpread(_objectSpread({}, file), {}, {
                id: id
            });
        });
        return newList;
    }, [value]);
    var handleClose = function () {
        setAnchor(null);
    };
    var handleDeleteFile = useCallback(function (e, item) { return __awaiter(void 0, void 0, void 0, function () {
        var id, res, filtered;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.stopPropagation();
                    id = item.id;
                    if (!!((value === null || value === void 0 ? void 0 : value[id]) instanceof File)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (deleteAttachmentAPI === null || deleteAttachmentAPI === void 0 ? void 0 : deleteAttachmentAPI({
                            request: _objectSpread(_objectSpread({}, deleteAttachmentRequest), item)
                        }))];
                case 1:
                    res = _a.sent();
                    if (!(res !== null && res !== void 0 && res.success))
                        return [2 /*return*/];
                    _a.label = 2;
                case 2:
                    filtered = value === null || value === void 0 ? void 0 : value.filter(function (item, index) { return index !== Number(id); });
                    if ((filtered === null || filtered === void 0 ? void 0 : filtered.length) === 0)
                        handleClose();
                    onChange === null || onChange === void 0 || onChange(e, filtered);
                    return [2 /*return*/];
            }
        });
    }); }, [value, onChange]);
    var handleAttachmentDownload = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var fileName, _link$parentNode, request, res, url, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (value instanceof File)
                        return [2 /*return*/];
                    fileName = value === null || value === void 0 ? void 0 : value.Name;
                    if (!(downloadAttachmentAPI && value)) return [3 /*break*/, 2];
                    request = _objectSpread(_objectSpread({}, downloadAttachmentRequest), value);
                    return [4 /*yield*/, downloadAttachmentAPI({
                            request: request
                        })];
                case 1:
                    res = _a.sent();
                    url = URL.createObjectURL(res === null || res === void 0 ? void 0 : res.data);
                    link = document.createElement('a');
                    link.download = fileName;
                    link.href = url;
                    document.body.appendChild(link);
                    link.click();
                    (_link$parentNode = link.parentNode) === null || _link$parentNode === void 0 || _link$parentNode.removeChild(link);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = useCallback(function (e) {
        var files = value !== null && value !== void 0 && value.length ? __spreadArray(__spreadArray([], value, true), e.target.files, true) : Array.from(e.target.files);
        e.target.value = '';
        onChange === null || onChange === void 0 || onChange(e, files);
    }, [value, onChange]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        columnGap: 1
    }, /*#__PURE__*/ React.createElement(Button, _extends({
        id: "upload-attachment",
        component: "label",
        variant: "outlined",
        color: "secondary",
        startIcon: /*#__PURE__*/ React.createElement(Upload, {
            fontSize: "inherit"
        }),
        sx: {
            px: 2
        },
        disabled: disabled
    }, uploadButtonProps), placeholder, /*#__PURE__*/ React.createElement(InputBase, _extends({
        id: "upload-input",
        onChange: handleChange,
        fullWidth: true,
        inputProps: {
            accept: '.pdf'
        }
    }, others, {
        type: "file",
        sx: _objectSpread({
            visibility: 'hidden',
            position: 'absolute'
        }, others.sx)
    }))), /*#__PURE__*/ React.createElement(Button, _extends({
        id: "view-attachment",
        variant: "outlined",
        color: "secondary",
        startIcon: /*#__PURE__*/ React.createElement(AttachFileOutlined, {
            fontSize: "inherit",
            color: "inherit",
            sx: {
                transform: 'rotate(45deg)'
            }
        }),
        onClick: function (e) {
            (value === null || value === void 0 ? void 0 : value.length) && setAnchor(function (prev) { return prev ? null : e.currentTarget; });
        }
    }, attachmentButtonProps), (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0)), error && /*#__PURE__*/ React.createElement(Typography, {
        color: "error",
        fontSize: 12,
        mx: 1
    }, error), /*#__PURE__*/ React.createElement(Menu, {
        open: Boolean(anchor),
        anchorEl: anchor,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        onClose: handleClose,
        sx: {
            transform: 'translateY(-8px)'
        },
        elevation: 4
    }, (_buildFilesArray = buildFilesArray(value)) === null || _buildFilesArray === void 0 ? void 0 : _buildFilesArray.map(function (item, i, arr) { /*#__PURE__*/ return React.createElement(FileItem, {
        item: item,
        disabled: disabled,
        divider: i !== arr.length - 1,
        onDelete: function (e) { return handleDeleteFile(e, item); }
    }); })));
};
import { InsertDriveFile as FileIcon } from "@mui/icons-material";
import { DocFileIconSVG, ImageFileIconSVG, XlsFileIconSVG } from '../../../../assets/customIcons';
export var renderIcon = function (fileName) {
    var _fileName$split$;
    var type = fileName === null || fileName === void 0 || (_fileName$split$ = fileName.split('.')[1]) === null || _fileName$split$ === void 0 ? void 0 : _fileName$split$.toLowerCase();
    switch (type) {
        case 'png':
        case 'jpg':
        case 'jpeg':
            return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                sx: {
                    width: 30,
                    height: 30,
                    color: 'secondary.200'
                }
            });
        case 'doc':
        case 'docx':
            return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                sx: {
                    width: 30,
                    height: 30,
                    color: 'secondary.200'
                }
            });
        case 'xls':
        case 'xlsx':
        case 'csv':
            return /*#__PURE__*/ React.createElement(XlsFileIconSVG, {
                sx: {
                    width: 30,
                    height: 30,
                    color: 'secondary.200'
                }
            });
        case 'pdf':
            return /*#__PURE__*/ React.createElement(PdfFile, {
                sx: {
                    width: 30,
                    height: 30,
                    color: 'secondary.200'
                }
            });
        default:
            return /*#__PURE__*/ React.createElement(FileIcon, {
                sx: {
                    width: 30,
                    height: 30,
                    color: 'secondary.200'
                }
            });
    }
};
var FileItem = function (props) {
    var item = props.item, onDelete = props.onDelete, disabled = props.disabled, other = _objectWithoutProperties(props, _excluded2);
    return /*#__PURE__*/ React.createElement(MenuItem, _extends({
        disableRipple: true,
        sx: {
            minWidth: 250,
            p: 2,
            columnGap: 1
        }
    }, other), /*#__PURE__*/ React.createElement(ListItemIcon, null, " ", renderIcon(item.Name), " "), /*#__PURE__*/ React.createElement(Box, {
        width: "100%",
        mr: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg"
    }, item.Name), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        color: "secondary"
    }, Math.round((Number(item.Size) || 0) / 1024), " KB")), !disabled && /*#__PURE__*/ React.createElement(IconButton, {
        id: item.id,
        size: "medium",
        onClick: onDelete
    }, /*#__PURE__*/ React.createElement(Delete, {
        color: "secondary",
        fontSize: "small"
    })));
};
